import { atom } from "jotai";

export const transparentNavbar = atom(false);